import PropTypes from 'prop-types';
import { Button, CardActions, Typography } from '@mui/material';

const styles = {
  cardActions: {
    padding: 'unset',
    paddingTop: 2,
    justifyContent: 'flex-end',
  },
  showMoreButton: {
    minWidth: 'unset !important',
    padding: 'unset !important',
  },
};

export const UserCardActions = ({ expanded, toggleExpanded }) => (
  <CardActions sx={styles.cardActions}>
    <Button variant="text" onClick={toggleExpanded} sx={styles.showMoreButton}>
      <Typography variant="body2-bold" color="primary" textAlign="right">
        {expanded ? 'Hide info' : 'More info'}
      </Typography>
    </Button>
  </CardActions>
);

UserCardActions.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
};
